module.exports = __webpack_public_path__ + "img/topografie-1.48a6dce7.png";